import moment from 'moment';

export class DateTimeUtil {
  private static readonly SUNDAY = 0;
  private static readonly SATURDAY = 6;

  static businessDaysFrom(date: Date | string, businessDays: number): Date {
    const currentDate = moment(date).toDate(),
      increment = businessDays > 0 ? 1 : -1;
    let numberOfDaysLeft = Math.abs(businessDays);
    while (numberOfDaysLeft > 0) {
      currentDate.setDate(currentDate.getDate() + increment);

      if (!this.isWeekend(currentDate)) {
        numberOfDaysLeft--;
      }
    }
    return currentDate;
  }

  static getNthWorkingDay(date: Date, n: number): Date | null {
    if (n < 1) {
      throw new Error('n must be a positive integer.');
    }

    const year = date.getFullYear();
    const month = date.getMonth();
    let workingDayCount = 0;

    // Start iterating from the 1st day of the month
    for (let day = 1; day <= 31; day++) {
      const currentDate = new Date(year, month, day);

      // Check if the date is valid (to handle months with fewer than 31 days)
      if (currentDate.getMonth() !== month) {
        break;
      }

      const dayOfWeek = currentDate.getDay();

      // Skip weekends (Saturday and Sunday)
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        workingDayCount++;
        if (workingDayCount === n) {
          return currentDate;
        }
      }
    }
    return null;
  }

  static getFirstDayOfCurrentMonth(): Date {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), 1);
  }

  private static isWeekend(date: Date): boolean {
    return [this.SUNDAY, this.SATURDAY].includes(date?.getDay());
  }
}
